/*
 * @Author: etong
 * @Date: 2023-06-05 16:34:15
 * @LastEditTime: 2023-06-06 14:19:40
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\utils\auth.js
 * Think first, Program later
 */
import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRouters(token) {
  return window.localStorage.getItem('router')
}
export function setRouters(router) {
  window.localStorage.setItem('router', router)
}
// 薪资校验token
export function getTokenRequest() {
  return window.localStorage.getItem('request_token')
}
